/* eslint-disable max-len */

import BchQuestion from 'images/coin-pages/questions/bch.svg'

import { slides } from 'pages/home/components/swiper-component/assets/slides'

import { ICoinPageData } from '../types'

export const bchPage: ICoinPageData = {
  title: 'coin_125',
  description: 'coin_126',
  // description:
  //   'Bitcoin Cash lending means enabling all owners of BCH to get an instant loan without changing to other currencies. Get an instant loan in Bitcoin Cash.',
  questionsBlock: {
    image: BchQuestion,
    questions: [
      {
        title: 'coin_127',
        answer: 'coin_128',
      },
      {
        title: 'coin_129',
        answer: 'coin_130',
      },
      {
        title: 'coin_131',
        answer: 'coin_132',
      },
      {
        title: 'coin_133',
        answer: 'coin_134',
      },
      {
        title: 'coin_135',
        answer: 'coin_136',
      },
    ],
  },
  whatIs: {
    slides: slides,
    text: [],
    paragraphs: [
      {
        title: 'coin_137',
        text: ['coin_142'],
      },
      {
        title: 'coin_138',
        text: ['coin_143'],
      },
      {
        title: 'coin_139',
        text: ['coin_144'],
      },
      {
        title: 'coin_140',
        text: ['coin_145', 'coin_146', 'coin_147', 'coin_148'],
      },
      {
        title: 'coin_141',
        text: ['coin_149', 'coin_150', 'coin_151', 'coin_152'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-platform-coinrabbit/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'Bitcoin cash crypto review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2022/03/integration-137CR_LQ.png',
        imageAlt: 'Bitcoin cash crypto review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/crypto-lending-growing-market-emerges-opportunities/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2021/05/photo_2021-05-26_21-10-19.jpg',
        imageAlt: 'Bitcoin cash crypto review 7',
      },
    ],
  },
}
